/**
 * Everything in here is copied from @formatjs/intl-datetimeformat (add-all-tz
 * and locale-data/en) and pared down as small as possible (in theory).
 */

if ('DateTimeFormat' in Intl && Intl.DateTimeFormat.__addTZData) {
  Intl.DateTimeFormat.__addTZData({
    zones: [
      'America/New_York|,0,148,0|-18y0os0,48,62,0|-r0ev81,48,62,0|-r0ev80,61,41,1|-qpm201,61,41,1|-qpm200,48,62,0|-qhosk1,48,62,0|-qhosk0,61,41,1|-q6vzc1,61,41,1|-q6vzc0,48,62,0|-pyypw1,48,62,0|-pyypw0,61,41,1|-pnsy01,61,41,1|-pnsy00,48,62,0|-pessk1,48,62,0|-pessk0,61,41,1|-p6voo1,61,41,1|-p6voo0,48,62,0|-ovpr81,48,62,0|-ovpr80,61,41,1|-oo5m01,61,41,1|-oo5m00,48,62,0|-oczok1,48,62,0|-oczok0,61,41,1|-o52ko1,61,41,1|-o52ko0,48,62,0|-nu9lw1,48,62,0|-nu9lw0,61,41,1|-nmci01,61,41,1|-nmci00,48,62,0|-nbjj81,48,62,0|-nbjj80,61,41,1|-n3mfc1,61,41,1|-n3mfc0,48,62,0|-mstgk1,48,62,0|-mstgk0,61,41,1|-mkwco1,61,41,1|-mkwco0,48,62,0|-ma3dw1,48,62,0|-ma3dw0,61,41,1|-m26a01,61,41,1|-m26a00,48,62,0|-lr0ck1,48,62,0|-lr0ck0,61,41,1|-lj38o1,61,41,1|-lj38o0,48,62,0|-l8a9w1,48,62,0|-l8a9w0,61,41,1|-l0d601,61,41,1|-l0d600,48,62,0|-kpk781,48,62,0|-kpk780,61,41,1|-khn3c1,61,41,1|-khn3c0,48,62,0|-k6u4k1,48,62,0|-k6u4k0,61,41,1|-jyx0o1,61,41,1|-jyx0o0,48,62,0|-jo41w1,48,62,0|-jo41w0,61,41,1|-jg6y01,61,41,1|-jg6y00,48,62,0|-j510k1,48,62,0|-j510k0,61,41,1|-ixgvc1,61,41,1|-ixgvc0,48,62,0|-imaxw1,48,62,0|-imaxw0,61,41,1|-iedu01,61,41,1|-iedu00,48,62,0|-i3kv81,48,62,0|-i3kv80,61,41,1|-hvnrc1,61,41,1|-hvnrc0,48,62,0|-hkusk1,48,62,0|-hkusk0,61,41,1|-hcxoo1,61,41,1|-hcxoo0,48,62,0|-h24pw1,48,62,0|-h24pw0,61,41,1|-gu7m01,61,41,1|-gu7m00,48,62,0|-gjen81,48,62,0|-gjen80,61,41,1|-gbhjc1,61,41,1|-gbhjc0,48,62,0|-g0blw1,48,62,0|-g0blw0,61,41,1|-fsrgo1,61,41,1|-fsrgo0,48,62,0|-fhlj81,48,62,0|-fhlj80,61,41,1|-f9ofc1,61,41,1|-f9ofc0,48,62,0|-eyvgk1,48,62,0|-eyvgk0,61,41,1|-eqyco1,61,41,1|-eqyco0,48,62,0|-ek24k1,48,62,0|-ek24k0,69,41,1|-cq2tg1,69,41,1|-cq2tg0,70,41,1|-cnp3c1,70,41,1|-cnp3c0,48,62,0|-ccw4k1,48,62,0|-ccw4k0,61,41,1|-c4z0o1,61,41,1|-c4z0o0,48,62,0|-bu61w1,48,62,0|-bu61w0,61,41,1|-bm8y01,61,41,1|-bm8y00,48,62,0|-bbfz81,48,62,0|-bbfz80,61,41,1|-b3ivc1,61,41,1|-b3ivc0,48,62,0|-aspwk1,48,62,0|-aspwk0,61,41,1|-aksso1,61,41,1|-aksso0,48,62,0|-a9mv81,48,62,0|-a9mv80,61,41,1|-a22q01,61,41,1|-a22q00,48,62,0|-9qwsk1,48,62,0|-9qwsk0,61,41,1|-9izoo1,61,41,1|-9izoo0,48,62,0|-986pw1,48,62,0|-986pw0,61,41,1|-909m01,61,41,1|-909m00,48,62,0|-8pgn81,48,62,0|-8pgn80,61,41,1|-8hjjc1,61,41,1|-8hjjc0,48,62,0|-86qkk1,48,62,0|-86qkk0,61,41,1|-7ytgo1,61,41,1|-7ytgo0,48,62,0|-7o0hw1,48,62,0|-7o0hw0,61,41,1|-7eako1,61,41,1|-7eako0,48,62,0|-74xgk1,48,62,0|-74xgk0,61,41,1|-6vki01,61,41,1|-6vki00,48,62,0|-6m7dw1,48,62,0|-6m7dw0,61,41,1|-6cufc1,61,41,1|-6cufc0,48,62,0|-63hb81,48,62,0|-63hb80,61,41,1|-5u4co1,61,41,1|-5u4co0,48,62,0|-5kr8k1,48,62,0|-5kr8k0,61,41,1|-5bea01,61,41,1|-5bea00,48,62,0|-5215w1,48,62,0|-5215w0,61,41,1|-4sb8o1,61,41,1|-4sb8o0,48,62,0|-4iy4k1,48,62,0|-4iy4k0,61,41,1|-49l601,61,41,1|-49l600,48,62,0|-4081w1,48,62,0|-4081w0,61,41,1|-3qv3c1,61,41,1|-3qv3c0,48,62,0|-3hhz81,48,62,0|-3hhz80,61,41,1|-3850o1,61,41,1|-3850o0,48,62,0|-2yrwk1,48,62,0|-2yrwk0,61,41,1|-2pey01,61,41,1|-2pey00,48,62,0|-2g1tw1,48,62,0|-2g1tw0,61,41,1|-26bwo1,61,41,1|-26bwo0,48,62,0|-1xbr81,48,62,0|-1xbr80,61,41,1|-1nlu01,61,41,1|-1nlu00,48,62,0|-1e8pw1,48,62,0|-1e8pw0,61,41,1|-14vrc1,61,41,1|-14vrc0,48,62,0|-vin81,48,62,0|-vin80,61,41,1|-m5oo1,61,41,1|-m5oo0,48,62,0|-cskk1,48,62,0|-cskk0,61,41,1|-3fm01,61,41,1|-3fm00,48,62,0|5xi3z,48,62,0|5xi40,61,41,1|fagnz,61,41,1|fago0,48,62,0|onkrz,48,62,0|onks0,61,41,1|ydhzz,61,41,1|ydi00,48,62,0|17qm3z,48,62,0|17qm40,61,41,1|1h3knz,61,41,1|1h3ko0,48,62,0|1qgorz,48,62,0|1qgos0,61,41,1|1ztnbz,61,41,1|1ztnc0,48,62,0|23fcrz,48,62,0|23fcs0,61,41,1|2ijpzz,61,41,1|2ijq00,48,62,0|2oo63z,48,62,0|2oo640,61,41,1|319snz,61,41,1|319so0,48,62,0|3amwrz,48,62,0|3amws0,61,41,1|3kctzz,61,41,1|3kcu00,48,62,0|3tczfz,48,62,0|3tczg0,61,41,1|432wnz,61,41,1|432wo0,48,62,0|4cg0rz,48,62,0|4cg0s0,61,41,1|4lszbz,61,41,1|4lszc0,48,62,0|4v63fz,48,62,0|4v63g0,61,41,1|54j1zz,61,41,1|54j200,48,62,0|5dw63z,48,62,0|5dw640,61,41,1|5n94nz,61,41,1|5n94o0,48,62,0|5wm8rz,48,62,0|5wm8s0,61,41,1|65z7bz,61,41,1|65z7c0,48,62,0|6fcbfz,48,62,0|6fcbg0,61,41,1|6p28nz,61,41,1|6p28o0,48,62,0|6y2e3z,48,62,0|6y2e40,61,41,1|77sbbz,61,41,1|77sbc0,48,62,0|7h5ffz,48,62,0|7h5fg0,61,41,1|7qidzz,61,41,1|7qie00,48,62,0|7zvi3z,48,62,0|7zvi40,61,41,1|898gnz,61,41,1|898go0,48,62,0|8ilkrz,48,62,0|8ilks0,61,41,1|8ryjbz,61,41,1|8ryjc0,48,62,0|908rfz,48,62,0|908rg0,61,41,1|9aolzz,61,41,1|9aom00,48,62,0|9iyu3z,48,62,0|9iyu40,61,41,1|9trnbz,61,41,1|9trnc0,48,62,0|a1owrz,48,62,0|a1ows0,61,41,1|achpzz,61,41,1|achq00,48,62,0|akezfz,48,62,0|akezg0,61,41,1|av7snz,61,41,1|av7so0,48,62,0|b3i0rz,48,62,0|b3i0s0,61,41,1|bdxvbz,61,41,1|bdxvc0,48,62,0|bm83fz,48,62,0|bm83g0,61,41,1|bwnxzz,61,41,1|bwny00,48,62,0|c4y63z,48,62,0|c4y640,61,41,1|cfqzbz,61,41,1|cfqzc0,48,62,0|cno8rz,48,62,0|cno8s0,61,41,1|cyh1zz,61,41,1|cyh200,48,62,0|d6ebfz,48,62,0|d6ebg0,61,41,1|dh74nz,61,41,1|dh74o0,48,62,0|dphcrz,48,62,0|dphcs0,61,41,1|dzx7bz,61,41,1|dzx7c0,48,62,0|e87ffz,48,62,0|e87fg0,61,41,1|ein9zz,61,41,1|eina00,48,62,0|eqxi3z,48,62,0|eqxi40,61,41,1|f1dcnz,61,41,1|f1dco0,48,62,0|f9nkrz,48,62,0|f9nks0,61,41,1|fkgdzz,61,41,1|fkge00,48,62,0|fsdnfz,48,62,0|fsdng0,61,41,1|g36gnz,61,41,1|g36go0,48,62,0|gb3q3z,48,62,0|gb3q40,61,41,1|glwjbz,61,41,1|glwjc0,48,62,0|gu6rfz,48,62,0|gu6rg0,61,41,1|h4mlzz,61,41,1|h4mm00,48,62,0|hcwu3z,48,62,0|hcwu40,61,41,1|hnconz,61,41,1|hncoo0,48,62,0|hvmwrz,48,62,0|hvmws0,61,41,1|i6fpzz,61,41,1|i6fq00,48,62,0|ieczfz,48,62,0|ieczg0,61,41,1|ip5snz,61,41,1|ip5so0,48,62,0|ix323z,48,62,0|ix3240,61,41,1|j7vvbz,61,41,1|j7vvc0,48,62,0|jeq8rz,48,62,0|jeq8s0,61,41,1|jqywnz,61,41,1|jqywo0,48,62,0|jxgbfz,48,62,0|jxgbg0,61,41,1|k9ozbz,61,41,1|k9ozc0,48,62,0|kg6e3z,48,62,0|kg6e40,61,41,1|ksf1zz,61,41,1|ksf200,48,62,0|kz9ffz,48,62,0|kz9fg0,61,41,1|lbi3bz,61,41,1|lbi3c0,48,62,0|lhzi3z,48,62,0|lhzi40,61,41,1|lu85zz,61,41,1|lu8600,48,62,0|m0pkrz,48,62,0|m0pks0,61,41,1|mcy8nz,61,41,1|mcy8o0,48,62,0|mjfnfz,48,62,0|mjfng0,61,41,1|mvobbz,61,41,1|mvobc0,48,62,0|n25q3z,48,62,0|n25q40,61,41,1|needzz,61,41,1|neee00,48,62,0|nkvsrz,48,62,0|nkvss0,61,41,1|nx4gnz,61,41,1|nx4go0,48,62,0|o3yu3z,48,62,0|o3yu40,61,41,1|og7hzz,61,41,1|og7i00,48,62,0|omowrz,48,62,0|omows0,61,41,1|oyxknz,61,41,1|oyxko0,48,62,0|p5ezfz,48,62,0|p5ezg0,61,41,1|phnnbz,61,41,1|phnnc0,48,62,0|po523z,48,62,0|po5240,61,41,1|q0dpzz,61,41,1|q0dq00,48,62,0|q6v4rz,48,62,0|q6v4s0,61,41,1|qj3snz,61,41,1|qj3so0,48,62,0|qpy63z,48,62,0|qpy640,61,41,1|r26tzz,61,41,1|r26u00,48,62,0|r8o8rz,48,62,0|r8o8s0,61,41,1|rkwwnz,61,41,1|rkwwo0,48,62,0|rrebfz,48,62,0|rrebg0,61,41,1|s3mzbz,61,41,1|s3mzc0,48,62,0|sa4e3z,48,62,0|sa4e40,61,41,1|smd1zz,61,41,1|smd200,48,62,0|ssugrz,48,62,0|ssugs0,61,41,1|t534nz,61,41,1|t534o0,48,62,0|tbkjfz,48,62,0|tbkjg0,61,41,1|tnt7bz,61,41,1|tnt7c0,48,62,0|tunkrz,48,62,0|tunks0,61,41,1|u6w8nz,61,41,1|u6w8o0,48,62,0|uddnfz,48,62,0|uddng0,61,41,1|upmbbz,61,41,1|upmbc0,48,62,0|uw3q3z,48,62,0|uw3q40,61,41,1|v8cdzz,61,41,1|v8ce00,48,62,0|vetsrz,48,62,0|vetss0,61,41,1|vr2gnz,61,41,1|vr2go0,48,62,0|vxjvfz,48,62,0|vxjvg0,61,41,1|w9sjbz,61,41,1|w9sjc0,48,62,0|wgmwrz,48,62,0|wgmws0,61,41,1|wsvknz,61,41,1|wsvko0,48,62,0|wzczfz,48,62,0|wzczg0,61,41,1|xblnbz,61,41,1|xblnc0,48,62,0|xi323z,48,62,0|xi3240,61,41,1|xubpzz,61,41,1|xubq00,48,62,0|y0t4rz,48,62,0|y0t4s0,61,41,1|yd1snz,61,41,1|yd1so0,48,62,0|yjj7fz,48,62,0|yjj7g0,61,41,1|yvrvbz,61,41,1|yvrvc0,48,62,0|z29a3z,48,62,0|z29a40,61,41,1|zehxzz,61,41,1|zehy00,48,62,0',
    ],
    abbrvs: 'EST|EDT',
    offsets:
      // Not sure how to shorten this
      '-qw|0|-1g|xc|6tg|8c0|6y0|7n0|kc|fl|2s0|5k0|mo|-2vw|-2s0|618|5sl|-1ek|-zg|-2g0|56o|460|5us|60w|-1zw|-226|2sc|18w|-1p9|2fw|1vw|360|xya|-wpq|-uk0|-rs0|-p00|12wo|-rrc|-m80|-be4|-b40|-8xc|-8c0|-5k0|-ato|-bw0|-c6k|-c3c|-cdo|-cqs|-ctg|-c44|-cos|-cac|-c2s|-cnc|-crn|-ci0|-aog|-gys|-go0|-dw0|-74s|-jho|-jg0|-b1h|-8z8|-gc0|-fa0|-aks|-b8g|-dps|-lip|-a44|-g2g|-ce8|-ce4|-9ow|-eq8|-eso|-g8c|-jn8|-fkd|-lks|-adw|-3gg|-ptg|-m9k|-jfw|-fdn|-l0g|-cxs|-gio|-mpz|-74o|-b3o|-b6s|-9rg|-6zg|-9q0|-6y0|-d68|-e7y|-grg|-es8|-ejc|-ars|-af0|-bs0|-f94|-f9c|-kjs|-fye|-g1i|-fzn|-g5v|-g2f|-fr4|-g7j|-g1d|15rv|-ow5|-fvq|-fpo|-cmc|-9uc|-e9o|-eac|-lwa|-6m4|-fz8|-fzc|-b44|-bb8|-iio|-jpg|-g83|-glg|16au|-od6|-id0|-aeg|-bzw|-iks|-aer|-460|-ebu|-dpe|-gcg|101a|-umq|-604|-iuj|-irc|-is3|-9kw|-jc4|-a7s|-a84|-a7o|-kr6|-de8|-ddo|-bu0|-c8p|-d4s|-d3a|-hig|-6go|-jdo|-ck0|-a4o|-cy0|-cyo|-8ms|-42g|15lz|-p21|-jyw|-g5g|-cqk|-gj0|-lo4|-ep8|-mss|-p0c|-hzo|14sh|-pvj|m80|uk0|jg0|dw0|rs0|go0|wd4|vy0|yq0|xc0|1040|1zo|8ng|e90|6nk|wv8|12w0|9b4|b40|al4|at8|9m8|884|880|9jk|98c|im4|fic|6ko|dtc|la4|ku0|l0g|p00|l7c|esc|esk|fa0|i20|6q0|gqs|gcw|n98|a8o|cqo|6ac|6ds|6hz|jr4|jqu|l56|nm0|gz0|jb5|js0|kdc|q20|qe0|6iu|6ig|ctc|ci0|tdo|cf0|fss|fz0|p3p|gd4|eva|h72|ity|j8d|kfk|n5c|l0y|rxc|m40|-189c|meo|66g|g5c|fcs|dl6|9ic|k8w|nac|bs4|c4g|qfc|ceh|nig|mhj|sgs|mi0|ctz|8an|9iw|9q0|glo|pvn|fqf|jsk|g7w|qiu|of7|o0y|htb|b89|af5|88o|-4r4|-5aw|-c06|-2uo|-4cs|-194|-34o|-42o|-6rk|-apo|pnw|t60|sc8|q70|qn4|o88|nv4|ob0|r30|ra4|rl8|tgk|qug|lgc|s04|wk|3ok|3pc|a4|8wc|4e4|3so|2h4|2o8|t6|4u0|3j8|1kw|1dm|5c8|5bo|2bw|-15o|-169|1lr|-zo|-23|4md|5d4|5ew|5ng|97c|150|-ok|2os|53s|53c|1d8|6yh|707|9s7|ck7|4gy|78y|2b8|99w|8j6|6bc|6ao|4bg|3cc|2se|4l0|3o8|8yo|44o|30x|4os|3w0|4fc|6hc|des|jks|hy4|a9o|dm0|anc|a9s|yv4|-vsw|-vy0|st4|r8w|xz0|y10|zf0|1270|-12k4|s3w|-k94|v64|-vok|-xc0|-vpk|x4w|x6s|-glc|-ozo|tmc|-13v0|qt0|-t8e|-t60|-qe0|-t4w|-tmo|-10hg|u6k|uzk|vpc|-pu0|z20|-vm0|uws|-vgs|-vhc|v3s|v40|uto|-15rg|owk|-o38|-nm0|-11d8|tas|r94|-tl4|-rp4|w1g|y88|y9c|uus|y1k',
  });
}

if (
  Intl.DateTimeFormat &&
  typeof Intl.DateTimeFormat.__addLocaleData === 'function'
) {
  Intl.DateTimeFormat.__addLocaleData({
    data: {
      am: 'AM',
      pm: 'PM',
      weekday: {
        narrow: ['S', 'M', 'T', 'W', 'T', 'F', 'S'],
        short: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
        long: [
          'Sunday',
          'Monday',
          'Tuesday',
          'Wednesday',
          'Thursday',
          'Friday',
          'Saturday',
        ],
      },
      era: {
        narrow: { BC: 'B', AD: 'A' },
        short: { BC: 'BC', AD: 'AD' },
        long: { BC: 'Before Christ', AD: 'Anno Domini' },
      },
      month: {
        narrow: ['J', 'F', 'M', 'A', 'M', 'J', 'J', 'A', 'S', 'O', 'N', 'D'],
        short: [
          'Jan',
          'Feb',
          'Mar',
          'Apr',
          'May',
          'Jun',
          'Jul',
          'Aug',
          'Sep',
          'Oct',
          'Nov',
          'Dec',
        ],
        long: [
          'January',
          'February',
          'March',
          'April',
          'May',
          'June',
          'July',
          'August',
          'September',
          'October',
          'November',
          'December',
        ],
      },
      timeZoneName: {
        'America/New_York': {
          long: ['Eastern Standard Time', 'Eastern Daylight Time'],
          short: ['EST', 'EDT'],
        },
      },
      gmtFormat: 'GMT{0}',
      hourFormat: '+HH:mm;-HH:mm',
      dateFormat: {
        full: 'EEEE, MMMM d, y',
        long: 'MMMM d, y',
        medium: 'MMM d, y',
        short: 'M/d/yy',
      },
      timeFormat: {
        full: 'h:mm:ss a zzzz',
        long: 'h:mm:ss a z',
        medium: 'h:mm:ss a',
        short: 'h:mm a',
      },
      dateTimeFormat: {
        full: "{1} 'at' {0}",
        long: "{1} 'at' {0}",
        medium: '{1}, {0}',
        short: '{1}, {0}',
      },
      formats: {
        gregory: {
          Bh: 'h B',
          Bhm: 'h:mm B',
          Bhms: 'h:mm:ss B',
          d: 'd',
          E: 'ccc',
          EBhm: 'E h:mm B',
          EBhms: 'E h:mm:ss B',
          Ed: 'd E',
          Ehm: 'E h:mm a',
          EHm: 'E HH:mm',
          Ehms: 'E h:mm:ss a',
          EHms: 'E HH:mm:ss',
          Gy: 'y G',
          GyMMM: 'MMM y G',
          GyMMMd: 'MMM d, y G',
          GyMMMEd: 'E, MMM d, y G',
          h: 'h a',
          H: 'HH',
          hm: 'h:mm a',
          Hm: 'HH:mm',
          hms: 'h:mm:ss a',
          Hms: 'HH:mm:ss',
          hmsv: 'h:mm:ss a v',
          Hmsv: 'HH:mm:ss v',
          hmv: 'h:mm a v',
          Hmv: 'HH:mm v',
          M: 'L',
          Md: 'M/d',
          MEd: 'E, M/d',
          MMM: 'LLL',
          MMMd: 'MMM d',
          MMMEd: 'E, MMM d',
          MMMMd: 'MMMM d',
          ms: 'mm:ss',
          y: 'y',
          yM: 'M/y',
          yMd: 'M/d/y',
          yMEd: 'E, M/d/y',
          yMMM: 'MMM y',
          yMMMd: 'MMM d, y',
          yMMMEd: 'E, MMM d, y',
          yMMMM: 'MMMM y',
          'EEEE, MMMM d, y': 'EEEE, MMMM d, y',
          'MMMM d, y': 'MMMM d, y',
          'MMM d, y': 'MMM d, y',
          'M/d/yy': 'M/d/yy',
          'h:mm:ss a zzzz': 'h:mm:ss a zzzz',
          'h:mm:ss a z': 'h:mm:ss a z',
          'h:mm:ss a': 'h:mm:ss a',
          'h:mm a': 'h:mm a',
          "EEEE, MMMM d, y 'at' h:mm:ss a zzzz":
            "EEEE, MMMM d, y 'at' h:mm:ss a zzzz",
          "MMMM d, y 'at' h:mm:ss a zzzz": "MMMM d, y 'at' h:mm:ss a zzzz",
          'MMM d, y, h:mm:ss a zzzz': 'MMM d, y, h:mm:ss a zzzz',
          'M/d/yy, h:mm:ss a zzzz': 'M/d/yy, h:mm:ss a zzzz',
          'd, h:mm:ss a zzzz': 'd, h:mm:ss a zzzz',
          'E, h:mm:ss a zzzz': 'ccc, h:mm:ss a zzzz',
          'Ed, h:mm:ss a zzzz': 'd E, h:mm:ss a zzzz',
          'Gy, h:mm:ss a zzzz': 'y G, h:mm:ss a zzzz',
          'GyMMM, h:mm:ss a zzzz': 'MMM y G, h:mm:ss a zzzz',
          'GyMMMd, h:mm:ss a zzzz': 'MMM d, y G, h:mm:ss a zzzz',
          'GyMMMEd, h:mm:ss a zzzz': 'E, MMM d, y G, h:mm:ss a zzzz',
          'M, h:mm:ss a zzzz': 'L, h:mm:ss a zzzz',
          'Md, h:mm:ss a zzzz': 'M/d, h:mm:ss a zzzz',
          'MEd, h:mm:ss a zzzz': 'E, M/d, h:mm:ss a zzzz',
          'MMM, h:mm:ss a zzzz': 'LLL, h:mm:ss a zzzz',
          'MMMd, h:mm:ss a zzzz': 'MMM d, h:mm:ss a zzzz',
          'MMMEd, h:mm:ss a zzzz': 'E, MMM d, h:mm:ss a zzzz',
          "MMMMd 'at' h:mm:ss a zzzz": "MMMM d 'at' h:mm:ss a zzzz",
          'y, h:mm:ss a zzzz': 'y, h:mm:ss a zzzz',
          'yM, h:mm:ss a zzzz': 'M/y, h:mm:ss a zzzz',
          'yMd, h:mm:ss a zzzz': 'M/d/y, h:mm:ss a zzzz',
          'yMEd, h:mm:ss a zzzz': 'E, M/d/y, h:mm:ss a zzzz',
          'yMMM, h:mm:ss a zzzz': 'MMM y, h:mm:ss a zzzz',
          'yMMMd, h:mm:ss a zzzz': 'MMM d, y, h:mm:ss a zzzz',
          'yMMMEd, h:mm:ss a zzzz': 'E, MMM d, y, h:mm:ss a zzzz',
          "yMMMM 'at' h:mm:ss a zzzz": "MMMM y 'at' h:mm:ss a zzzz",
          "EEEE, MMMM d, y 'at' h:mm:ss a z":
            "EEEE, MMMM d, y 'at' h:mm:ss a z",
          "MMMM d, y 'at' h:mm:ss a z": "MMMM d, y 'at' h:mm:ss a z",
          'MMM d, y, h:mm:ss a z': 'MMM d, y, h:mm:ss a z',
          'M/d/yy, h:mm:ss a z': 'M/d/yy, h:mm:ss a z',
          'd, h:mm:ss a z': 'd, h:mm:ss a z',
          'E, h:mm:ss a z': 'ccc, h:mm:ss a z',
          'Ed, h:mm:ss a z': 'd E, h:mm:ss a z',
          'Gy, h:mm:ss a z': 'y G, h:mm:ss a z',
          'GyMMM, h:mm:ss a z': 'MMM y G, h:mm:ss a z',
          'GyMMMd, h:mm:ss a z': 'MMM d, y G, h:mm:ss a z',
          'GyMMMEd, h:mm:ss a z': 'E, MMM d, y G, h:mm:ss a z',
          'M, h:mm:ss a z': 'L, h:mm:ss a z',
          'Md, h:mm:ss a z': 'M/d, h:mm:ss a z',
          'MEd, h:mm:ss a z': 'E, M/d, h:mm:ss a z',
          'MMM, h:mm:ss a z': 'LLL, h:mm:ss a z',
          'MMMd, h:mm:ss a z': 'MMM d, h:mm:ss a z',
          'MMMEd, h:mm:ss a z': 'E, MMM d, h:mm:ss a z',
          "MMMMd 'at' h:mm:ss a z": "MMMM d 'at' h:mm:ss a z",
          'y, h:mm:ss a z': 'y, h:mm:ss a z',
          'yM, h:mm:ss a z': 'M/y, h:mm:ss a z',
          'yMd, h:mm:ss a z': 'M/d/y, h:mm:ss a z',
          'yMEd, h:mm:ss a z': 'E, M/d/y, h:mm:ss a z',
          'yMMM, h:mm:ss a z': 'MMM y, h:mm:ss a z',
          'yMMMd, h:mm:ss a z': 'MMM d, y, h:mm:ss a z',
          'yMMMEd, h:mm:ss a z': 'E, MMM d, y, h:mm:ss a z',
          "yMMMM 'at' h:mm:ss a z": "MMMM y 'at' h:mm:ss a z",
          "EEEE, MMMM d, y 'at' h:mm:ss a": "EEEE, MMMM d, y 'at' h:mm:ss a",
          "MMMM d, y 'at' h:mm:ss a": "MMMM d, y 'at' h:mm:ss a",
          'MMM d, y, h:mm:ss a': 'MMM d, y, h:mm:ss a',
          'M/d/yy, h:mm:ss a': 'M/d/yy, h:mm:ss a',
          'd, h:mm:ss a': 'd, h:mm:ss a',
          'E, h:mm:ss a': 'ccc, h:mm:ss a',
          'Ed, h:mm:ss a': 'd E, h:mm:ss a',
          'Gy, h:mm:ss a': 'y G, h:mm:ss a',
          'GyMMM, h:mm:ss a': 'MMM y G, h:mm:ss a',
          'GyMMMd, h:mm:ss a': 'MMM d, y G, h:mm:ss a',
          'GyMMMEd, h:mm:ss a': 'E, MMM d, y G, h:mm:ss a',
          'M, h:mm:ss a': 'L, h:mm:ss a',
          'Md, h:mm:ss a': 'M/d, h:mm:ss a',
          'MEd, h:mm:ss a': 'E, M/d, h:mm:ss a',
          'MMM, h:mm:ss a': 'LLL, h:mm:ss a',
          'MMMd, h:mm:ss a': 'MMM d, h:mm:ss a',
          'MMMEd, h:mm:ss a': 'E, MMM d, h:mm:ss a',
          "MMMMd 'at' h:mm:ss a": "MMMM d 'at' h:mm:ss a",
          'y, h:mm:ss a': 'y, h:mm:ss a',
          'yM, h:mm:ss a': 'M/y, h:mm:ss a',
          'yMd, h:mm:ss a': 'M/d/y, h:mm:ss a',
          'yMEd, h:mm:ss a': 'E, M/d/y, h:mm:ss a',
          'yMMM, h:mm:ss a': 'MMM y, h:mm:ss a',
          'yMMMd, h:mm:ss a': 'MMM d, y, h:mm:ss a',
          'yMMMEd, h:mm:ss a': 'E, MMM d, y, h:mm:ss a',
          "yMMMM 'at' h:mm:ss a": "MMMM y 'at' h:mm:ss a",
          "EEEE, MMMM d, y 'at' h:mm a": "EEEE, MMMM d, y 'at' h:mm a",
          "MMMM d, y 'at' h:mm a": "MMMM d, y 'at' h:mm a",
          'MMM d, y, h:mm a': 'MMM d, y, h:mm a',
          'M/d/yy, h:mm a': 'M/d/yy, h:mm a',
          'd, h:mm a': 'd, h:mm a',
          'E, h:mm a': 'ccc, h:mm a',
          'Ed, h:mm a': 'd E, h:mm a',
          'Gy, h:mm a': 'y G, h:mm a',
          'GyMMM, h:mm a': 'MMM y G, h:mm a',
          'GyMMMd, h:mm a': 'MMM d, y G, h:mm a',
          'GyMMMEd, h:mm a': 'E, MMM d, y G, h:mm a',
          'M, h:mm a': 'L, h:mm a',
          'Md, h:mm a': 'M/d, h:mm a',
          'MEd, h:mm a': 'E, M/d, h:mm a',
          'MMM, h:mm a': 'LLL, h:mm a',
          'MMMd, h:mm a': 'MMM d, h:mm a',
          'MMMEd, h:mm a': 'E, MMM d, h:mm a',
          "MMMMd 'at' h:mm a": "MMMM d 'at' h:mm a",
          'y, h:mm a': 'y, h:mm a',
          'yM, h:mm a': 'M/y, h:mm a',
          'yMd, h:mm a': 'M/d/y, h:mm a',
          'yMEd, h:mm a': 'E, M/d/y, h:mm a',
          'yMMM, h:mm a': 'MMM y, h:mm a',
          'yMMMd, h:mm a': 'MMM d, y, h:mm a',
          'yMMMEd, h:mm a': 'E, MMM d, y, h:mm a',
          "yMMMM 'at' h:mm a": "MMMM y 'at' h:mm a",
          "EEEE, MMMM d, y 'at' Bh": "EEEE, MMMM d, y 'at' h B",
          "MMMM d, y 'at' Bh": "MMMM d, y 'at' h B",
          'MMM d, y, Bh': 'MMM d, y, h B',
          'M/d/yy, Bh': 'M/d/yy, h B',
          'd, Bh': 'd, h B',
          'E, Bh': 'ccc, h B',
          'Ed, Bh': 'd E, h B',
          'Gy, Bh': 'y G, h B',
          'GyMMM, Bh': 'MMM y G, h B',
          'GyMMMd, Bh': 'MMM d, y G, h B',
          'GyMMMEd, Bh': 'E, MMM d, y G, h B',
          'M, Bh': 'L, h B',
          'Md, Bh': 'M/d, h B',
          'MEd, Bh': 'E, M/d, h B',
          'MMM, Bh': 'LLL, h B',
          'MMMd, Bh': 'MMM d, h B',
          'MMMEd, Bh': 'E, MMM d, h B',
          "MMMMd 'at' Bh": "MMMM d 'at' h B",
          'y, Bh': 'y, h B',
          'yM, Bh': 'M/y, h B',
          'yMd, Bh': 'M/d/y, h B',
          'yMEd, Bh': 'E, M/d/y, h B',
          'yMMM, Bh': 'MMM y, h B',
          'yMMMd, Bh': 'MMM d, y, h B',
          'yMMMEd, Bh': 'E, MMM d, y, h B',
          "yMMMM 'at' Bh": "MMMM y 'at' h B",
          "EEEE, MMMM d, y 'at' Bhm": "EEEE, MMMM d, y 'at' h:mm B",
          "MMMM d, y 'at' Bhm": "MMMM d, y 'at' h:mm B",
          'MMM d, y, Bhm': 'MMM d, y, h:mm B',
          'M/d/yy, Bhm': 'M/d/yy, h:mm B',
          'd, Bhm': 'd, h:mm B',
          'E, Bhm': 'ccc, h:mm B',
          'Ed, Bhm': 'd E, h:mm B',
          'Gy, Bhm': 'y G, h:mm B',
          'GyMMM, Bhm': 'MMM y G, h:mm B',
          'GyMMMd, Bhm': 'MMM d, y G, h:mm B',
          'GyMMMEd, Bhm': 'E, MMM d, y G, h:mm B',
          'M, Bhm': 'L, h:mm B',
          'Md, Bhm': 'M/d, h:mm B',
          'MEd, Bhm': 'E, M/d, h:mm B',
          'MMM, Bhm': 'LLL, h:mm B',
          'MMMd, Bhm': 'MMM d, h:mm B',
          'MMMEd, Bhm': 'E, MMM d, h:mm B',
          "MMMMd 'at' Bhm": "MMMM d 'at' h:mm B",
          'y, Bhm': 'y, h:mm B',
          'yM, Bhm': 'M/y, h:mm B',
          'yMd, Bhm': 'M/d/y, h:mm B',
          'yMEd, Bhm': 'E, M/d/y, h:mm B',
          'yMMM, Bhm': 'MMM y, h:mm B',
          'yMMMd, Bhm': 'MMM d, y, h:mm B',
          'yMMMEd, Bhm': 'E, MMM d, y, h:mm B',
          "yMMMM 'at' Bhm": "MMMM y 'at' h:mm B",
          "EEEE, MMMM d, y 'at' Bhms": "EEEE, MMMM d, y 'at' h:mm:ss B",
          "MMMM d, y 'at' Bhms": "MMMM d, y 'at' h:mm:ss B",
          'MMM d, y, Bhms': 'MMM d, y, h:mm:ss B',
          'M/d/yy, Bhms': 'M/d/yy, h:mm:ss B',
          'd, Bhms': 'd, h:mm:ss B',
          'E, Bhms': 'ccc, h:mm:ss B',
          'Ed, Bhms': 'd E, h:mm:ss B',
          'Gy, Bhms': 'y G, h:mm:ss B',
          'GyMMM, Bhms': 'MMM y G, h:mm:ss B',
          'GyMMMd, Bhms': 'MMM d, y G, h:mm:ss B',
          'GyMMMEd, Bhms': 'E, MMM d, y G, h:mm:ss B',
          'M, Bhms': 'L, h:mm:ss B',
          'Md, Bhms': 'M/d, h:mm:ss B',
          'MEd, Bhms': 'E, M/d, h:mm:ss B',
          'MMM, Bhms': 'LLL, h:mm:ss B',
          'MMMd, Bhms': 'MMM d, h:mm:ss B',
          'MMMEd, Bhms': 'E, MMM d, h:mm:ss B',
          "MMMMd 'at' Bhms": "MMMM d 'at' h:mm:ss B",
          'y, Bhms': 'y, h:mm:ss B',
          'yM, Bhms': 'M/y, h:mm:ss B',
          'yMd, Bhms': 'M/d/y, h:mm:ss B',
          'yMEd, Bhms': 'E, M/d/y, h:mm:ss B',
          'yMMM, Bhms': 'MMM y, h:mm:ss B',
          'yMMMd, Bhms': 'MMM d, y, h:mm:ss B',
          'yMMMEd, Bhms': 'E, MMM d, y, h:mm:ss B',
          "yMMMM 'at' Bhms": "MMMM y 'at' h:mm:ss B",
          "EEEE, MMMM d, y 'at' h": "EEEE, MMMM d, y 'at' h a",
          "MMMM d, y 'at' h": "MMMM d, y 'at' h a",
          'MMM d, y, h': 'MMM d, y, h a',
          'M/d/yy, h': 'M/d/yy, h a',
          'd, h': 'd, h a',
          'E, h': 'ccc, h a',
          'Ed, h': 'd E, h a',
          'Gy, h': 'y G, h a',
          'GyMMM, h': 'MMM y G, h a',
          'GyMMMd, h': 'MMM d, y G, h a',
          'GyMMMEd, h': 'E, MMM d, y G, h a',
          'M, h': 'L, h a',
          'Md, h': 'M/d, h a',
          'MEd, h': 'E, M/d, h a',
          'MMM, h': 'LLL, h a',
          'MMMd, h': 'MMM d, h a',
          'MMMEd, h': 'E, MMM d, h a',
          "MMMMd 'at' h": "MMMM d 'at' h a",
          'y, h': 'y, h a',
          'yM, h': 'M/y, h a',
          'yMd, h': 'M/d/y, h a',
          'yMEd, h': 'E, M/d/y, h a',
          'yMMM, h': 'MMM y, h a',
          'yMMMd, h': 'MMM d, y, h a',
          'yMMMEd, h': 'E, MMM d, y, h a',
          "yMMMM 'at' h": "MMMM y 'at' h a",
          "EEEE, MMMM d, y 'at' H": "EEEE, MMMM d, y 'at' HH",
          "MMMM d, y 'at' H": "MMMM d, y 'at' HH",
          'MMM d, y, H': 'MMM d, y, HH',
          'M/d/yy, H': 'M/d/yy, HH',
          'd, H': 'd, HH',
          'E, H': 'ccc, HH',
          'Ed, H': 'd E, HH',
          'Gy, H': 'y G, HH',
          'GyMMM, H': 'MMM y G, HH',
          'GyMMMd, H': 'MMM d, y G, HH',
          'GyMMMEd, H': 'E, MMM d, y G, HH',
          'M, H': 'L, HH',
          'Md, H': 'M/d, HH',
          'MEd, H': 'E, M/d, HH',
          'MMM, H': 'LLL, HH',
          'MMMd, H': 'MMM d, HH',
          'MMMEd, H': 'E, MMM d, HH',
          "MMMMd 'at' H": "MMMM d 'at' HH",
          'y, H': 'y, HH',
          'yM, H': 'M/y, HH',
          'yMd, H': 'M/d/y, HH',
          'yMEd, H': 'E, M/d/y, HH',
          'yMMM, H': 'MMM y, HH',
          'yMMMd, H': 'MMM d, y, HH',
          'yMMMEd, H': 'E, MMM d, y, HH',
          "yMMMM 'at' H": "MMMM y 'at' HH",
          "EEEE, MMMM d, y 'at' hm": "EEEE, MMMM d, y 'at' h:mm a",
          "MMMM d, y 'at' hm": "MMMM d, y 'at' h:mm a",
          'MMM d, y, hm': 'MMM d, y, h:mm a',
          'M/d/yy, hm': 'M/d/yy, h:mm a',
          'd, hm': 'd, h:mm a',
          'E, hm': 'ccc, h:mm a',
          'Ed, hm': 'd E, h:mm a',
          'Gy, hm': 'y G, h:mm a',
          'GyMMM, hm': 'MMM y G, h:mm a',
          'GyMMMd, hm': 'MMM d, y G, h:mm a',
          'GyMMMEd, hm': 'E, MMM d, y G, h:mm a',
          'M, hm': 'L, h:mm a',
          'Md, hm': 'M/d, h:mm a',
          'MEd, hm': 'E, M/d, h:mm a',
          'MMM, hm': 'LLL, h:mm a',
          'MMMd, hm': 'MMM d, h:mm a',
          'MMMEd, hm': 'E, MMM d, h:mm a',
          "MMMMd 'at' hm": "MMMM d 'at' h:mm a",
          'y, hm': 'y, h:mm a',
          'yM, hm': 'M/y, h:mm a',
          'yMd, hm': 'M/d/y, h:mm a',
          'yMEd, hm': 'E, M/d/y, h:mm a',
          'yMMM, hm': 'MMM y, h:mm a',
          'yMMMd, hm': 'MMM d, y, h:mm a',
          'yMMMEd, hm': 'E, MMM d, y, h:mm a',
          "yMMMM 'at' hm": "MMMM y 'at' h:mm a",
          "EEEE, MMMM d, y 'at' Hm": "EEEE, MMMM d, y 'at' HH:mm",
          "MMMM d, y 'at' Hm": "MMMM d, y 'at' HH:mm",
          'MMM d, y, Hm': 'MMM d, y, HH:mm',
          'M/d/yy, Hm': 'M/d/yy, HH:mm',
          'd, Hm': 'd, HH:mm',
          'E, Hm': 'ccc, HH:mm',
          'Ed, Hm': 'd E, HH:mm',
          'Gy, Hm': 'y G, HH:mm',
          'GyMMM, Hm': 'MMM y G, HH:mm',
          'GyMMMd, Hm': 'MMM d, y G, HH:mm',
          'GyMMMEd, Hm': 'E, MMM d, y G, HH:mm',
          'M, Hm': 'L, HH:mm',
          'Md, Hm': 'M/d, HH:mm',
          'MEd, Hm': 'E, M/d, HH:mm',
          'MMM, Hm': 'LLL, HH:mm',
          'MMMd, Hm': 'MMM d, HH:mm',
          'MMMEd, Hm': 'E, MMM d, HH:mm',
          "MMMMd 'at' Hm": "MMMM d 'at' HH:mm",
          'y, Hm': 'y, HH:mm',
          'yM, Hm': 'M/y, HH:mm',
          'yMd, Hm': 'M/d/y, HH:mm',
          'yMEd, Hm': 'E, M/d/y, HH:mm',
          'yMMM, Hm': 'MMM y, HH:mm',
          'yMMMd, Hm': 'MMM d, y, HH:mm',
          'yMMMEd, Hm': 'E, MMM d, y, HH:mm',
          "yMMMM 'at' Hm": "MMMM y 'at' HH:mm",
          "EEEE, MMMM d, y 'at' hms": "EEEE, MMMM d, y 'at' h:mm:ss a",
          "MMMM d, y 'at' hms": "MMMM d, y 'at' h:mm:ss a",
          'MMM d, y, hms': 'MMM d, y, h:mm:ss a',
          'M/d/yy, hms': 'M/d/yy, h:mm:ss a',
          'd, hms': 'd, h:mm:ss a',
          'E, hms': 'ccc, h:mm:ss a',
          'Ed, hms': 'd E, h:mm:ss a',
          'Gy, hms': 'y G, h:mm:ss a',
          'GyMMM, hms': 'MMM y G, h:mm:ss a',
          'GyMMMd, hms': 'MMM d, y G, h:mm:ss a',
          'GyMMMEd, hms': 'E, MMM d, y G, h:mm:ss a',
          'M, hms': 'L, h:mm:ss a',
          'Md, hms': 'M/d, h:mm:ss a',
          'MEd, hms': 'E, M/d, h:mm:ss a',
          'MMM, hms': 'LLL, h:mm:ss a',
          'MMMd, hms': 'MMM d, h:mm:ss a',
          'MMMEd, hms': 'E, MMM d, h:mm:ss a',
          "MMMMd 'at' hms": "MMMM d 'at' h:mm:ss a",
          'y, hms': 'y, h:mm:ss a',
          'yM, hms': 'M/y, h:mm:ss a',
          'yMd, hms': 'M/d/y, h:mm:ss a',
          'yMEd, hms': 'E, M/d/y, h:mm:ss a',
          'yMMM, hms': 'MMM y, h:mm:ss a',
          'yMMMd, hms': 'MMM d, y, h:mm:ss a',
          'yMMMEd, hms': 'E, MMM d, y, h:mm:ss a',
          "yMMMM 'at' hms": "MMMM y 'at' h:mm:ss a",
          "EEEE, MMMM d, y 'at' Hms": "EEEE, MMMM d, y 'at' HH:mm:ss",
          "MMMM d, y 'at' Hms": "MMMM d, y 'at' HH:mm:ss",
          'MMM d, y, Hms': 'MMM d, y, HH:mm:ss',
          'M/d/yy, Hms': 'M/d/yy, HH:mm:ss',
          'd, Hms': 'd, HH:mm:ss',
          'E, Hms': 'ccc, HH:mm:ss',
          'Ed, Hms': 'd E, HH:mm:ss',
          'Gy, Hms': 'y G, HH:mm:ss',
          'GyMMM, Hms': 'MMM y G, HH:mm:ss',
          'GyMMMd, Hms': 'MMM d, y G, HH:mm:ss',
          'GyMMMEd, Hms': 'E, MMM d, y G, HH:mm:ss',
          'M, Hms': 'L, HH:mm:ss',
          'Md, Hms': 'M/d, HH:mm:ss',
          'MEd, Hms': 'E, M/d, HH:mm:ss',
          'MMM, Hms': 'LLL, HH:mm:ss',
          'MMMd, Hms': 'MMM d, HH:mm:ss',
          'MMMEd, Hms': 'E, MMM d, HH:mm:ss',
          "MMMMd 'at' Hms": "MMMM d 'at' HH:mm:ss",
          'y, Hms': 'y, HH:mm:ss',
          'yM, Hms': 'M/y, HH:mm:ss',
          'yMd, Hms': 'M/d/y, HH:mm:ss',
          'yMEd, Hms': 'E, M/d/y, HH:mm:ss',
          'yMMM, Hms': 'MMM y, HH:mm:ss',
          'yMMMd, Hms': 'MMM d, y, HH:mm:ss',
          'yMMMEd, Hms': 'E, MMM d, y, HH:mm:ss',
          "yMMMM 'at' Hms": "MMMM y 'at' HH:mm:ss",
          "EEEE, MMMM d, y 'at' hmsv": "EEEE, MMMM d, y 'at' h:mm:ss a v",
          "MMMM d, y 'at' hmsv": "MMMM d, y 'at' h:mm:ss a v",
          'MMM d, y, hmsv': 'MMM d, y, h:mm:ss a v',
          'M/d/yy, hmsv': 'M/d/yy, h:mm:ss a v',
          'd, hmsv': 'd, h:mm:ss a v',
          'E, hmsv': 'ccc, h:mm:ss a v',
          'Ed, hmsv': 'd E, h:mm:ss a v',
          'Gy, hmsv': 'y G, h:mm:ss a v',
          'GyMMM, hmsv': 'MMM y G, h:mm:ss a v',
          'GyMMMd, hmsv': 'MMM d, y G, h:mm:ss a v',
          'GyMMMEd, hmsv': 'E, MMM d, y G, h:mm:ss a v',
          'M, hmsv': 'L, h:mm:ss a v',
          'Md, hmsv': 'M/d, h:mm:ss a v',
          'MEd, hmsv': 'E, M/d, h:mm:ss a v',
          'MMM, hmsv': 'LLL, h:mm:ss a v',
          'MMMd, hmsv': 'MMM d, h:mm:ss a v',
          'MMMEd, hmsv': 'E, MMM d, h:mm:ss a v',
          "MMMMd 'at' hmsv": "MMMM d 'at' h:mm:ss a v",
          'y, hmsv': 'y, h:mm:ss a v',
          'yM, hmsv': 'M/y, h:mm:ss a v',
          'yMd, hmsv': 'M/d/y, h:mm:ss a v',
          'yMEd, hmsv': 'E, M/d/y, h:mm:ss a v',
          'yMMM, hmsv': 'MMM y, h:mm:ss a v',
          'yMMMd, hmsv': 'MMM d, y, h:mm:ss a v',
          'yMMMEd, hmsv': 'E, MMM d, y, h:mm:ss a v',
          "yMMMM 'at' hmsv": "MMMM y 'at' h:mm:ss a v",
          "EEEE, MMMM d, y 'at' Hmsv": "EEEE, MMMM d, y 'at' HH:mm:ss v",
          "MMMM d, y 'at' Hmsv": "MMMM d, y 'at' HH:mm:ss v",
          'MMM d, y, Hmsv': 'MMM d, y, HH:mm:ss v',
          'M/d/yy, Hmsv': 'M/d/yy, HH:mm:ss v',
          'd, Hmsv': 'd, HH:mm:ss v',
          'E, Hmsv': 'ccc, HH:mm:ss v',
          'Ed, Hmsv': 'd E, HH:mm:ss v',
          'Gy, Hmsv': 'y G, HH:mm:ss v',
          'GyMMM, Hmsv': 'MMM y G, HH:mm:ss v',
          'GyMMMd, Hmsv': 'MMM d, y G, HH:mm:ss v',
          'GyMMMEd, Hmsv': 'E, MMM d, y G, HH:mm:ss v',
          'M, Hmsv': 'L, HH:mm:ss v',
          'Md, Hmsv': 'M/d, HH:mm:ss v',
          'MEd, Hmsv': 'E, M/d, HH:mm:ss v',
          'MMM, Hmsv': 'LLL, HH:mm:ss v',
          'MMMd, Hmsv': 'MMM d, HH:mm:ss v',
          'MMMEd, Hmsv': 'E, MMM d, HH:mm:ss v',
          "MMMMd 'at' Hmsv": "MMMM d 'at' HH:mm:ss v",
          'y, Hmsv': 'y, HH:mm:ss v',
          'yM, Hmsv': 'M/y, HH:mm:ss v',
          'yMd, Hmsv': 'M/d/y, HH:mm:ss v',
          'yMEd, Hmsv': 'E, M/d/y, HH:mm:ss v',
          'yMMM, Hmsv': 'MMM y, HH:mm:ss v',
          'yMMMd, Hmsv': 'MMM d, y, HH:mm:ss v',
          'yMMMEd, Hmsv': 'E, MMM d, y, HH:mm:ss v',
          "yMMMM 'at' Hmsv": "MMMM y 'at' HH:mm:ss v",
          "EEEE, MMMM d, y 'at' hmv": "EEEE, MMMM d, y 'at' h:mm a v",
          "MMMM d, y 'at' hmv": "MMMM d, y 'at' h:mm a v",
          'MMM d, y, hmv': 'MMM d, y, h:mm a v',
          'M/d/yy, hmv': 'M/d/yy, h:mm a v',
          'd, hmv': 'd, h:mm a v',
          'E, hmv': 'ccc, h:mm a v',
          'Ed, hmv': 'd E, h:mm a v',
          'Gy, hmv': 'y G, h:mm a v',
          'GyMMM, hmv': 'MMM y G, h:mm a v',
          'GyMMMd, hmv': 'MMM d, y G, h:mm a v',
          'GyMMMEd, hmv': 'E, MMM d, y G, h:mm a v',
          'M, hmv': 'L, h:mm a v',
          'Md, hmv': 'M/d, h:mm a v',
          'MEd, hmv': 'E, M/d, h:mm a v',
          'MMM, hmv': 'LLL, h:mm a v',
          'MMMd, hmv': 'MMM d, h:mm a v',
          'MMMEd, hmv': 'E, MMM d, h:mm a v',
          "MMMMd 'at' hmv": "MMMM d 'at' h:mm a v",
          'y, hmv': 'y, h:mm a v',
          'yM, hmv': 'M/y, h:mm a v',
          'yMd, hmv': 'M/d/y, h:mm a v',
          'yMEd, hmv': 'E, M/d/y, h:mm a v',
          'yMMM, hmv': 'MMM y, h:mm a v',
          'yMMMd, hmv': 'MMM d, y, h:mm a v',
          'yMMMEd, hmv': 'E, MMM d, y, h:mm a v',
          "yMMMM 'at' hmv": "MMMM y 'at' h:mm a v",
          "EEEE, MMMM d, y 'at' Hmv": "EEEE, MMMM d, y 'at' HH:mm v",
          "MMMM d, y 'at' Hmv": "MMMM d, y 'at' HH:mm v",
          'MMM d, y, Hmv': 'MMM d, y, HH:mm v',
          'M/d/yy, Hmv': 'M/d/yy, HH:mm v',
          'd, Hmv': 'd, HH:mm v',
          'E, Hmv': 'ccc, HH:mm v',
          'Ed, Hmv': 'd E, HH:mm v',
          'Gy, Hmv': 'y G, HH:mm v',
          'GyMMM, Hmv': 'MMM y G, HH:mm v',
          'GyMMMd, Hmv': 'MMM d, y G, HH:mm v',
          'GyMMMEd, Hmv': 'E, MMM d, y G, HH:mm v',
          'M, Hmv': 'L, HH:mm v',
          'Md, Hmv': 'M/d, HH:mm v',
          'MEd, Hmv': 'E, M/d, HH:mm v',
          'MMM, Hmv': 'LLL, HH:mm v',
          'MMMd, Hmv': 'MMM d, HH:mm v',
          'MMMEd, Hmv': 'E, MMM d, HH:mm v',
          "MMMMd 'at' Hmv": "MMMM d 'at' HH:mm v",
          'y, Hmv': 'y, HH:mm v',
          'yM, Hmv': 'M/y, HH:mm v',
          'yMd, Hmv': 'M/d/y, HH:mm v',
          'yMEd, Hmv': 'E, M/d/y, HH:mm v',
          'yMMM, Hmv': 'MMM y, HH:mm v',
          'yMMMd, Hmv': 'MMM d, y, HH:mm v',
          'yMMMEd, Hmv': 'E, MMM d, y, HH:mm v',
          "yMMMM 'at' Hmv": "MMMM y 'at' HH:mm v",
          "EEEE, MMMM d, y 'at' ms": "EEEE, MMMM d, y 'at' mm:ss",
          "MMMM d, y 'at' ms": "MMMM d, y 'at' mm:ss",
          'MMM d, y, ms': 'MMM d, y, mm:ss',
          'M/d/yy, ms': 'M/d/yy, mm:ss',
          'd, ms': 'd, mm:ss',
          'E, ms': 'ccc, mm:ss',
          'Ed, ms': 'd E, mm:ss',
          'Gy, ms': 'y G, mm:ss',
          'GyMMM, ms': 'MMM y G, mm:ss',
          'GyMMMd, ms': 'MMM d, y G, mm:ss',
          'GyMMMEd, ms': 'E, MMM d, y G, mm:ss',
          'M, ms': 'L, mm:ss',
          'Md, ms': 'M/d, mm:ss',
          'MEd, ms': 'E, M/d, mm:ss',
          'MMM, ms': 'LLL, mm:ss',
          'MMMd, ms': 'MMM d, mm:ss',
          'MMMEd, ms': 'E, MMM d, mm:ss',
          "MMMMd 'at' ms": "MMMM d 'at' mm:ss",
          'y, ms': 'y, mm:ss',
          'yM, ms': 'M/y, mm:ss',
          'yMd, ms': 'M/d/y, mm:ss',
          'yMEd, ms': 'E, M/d/y, mm:ss',
          'yMMM, ms': 'MMM y, mm:ss',
          'yMMMd, ms': 'MMM d, y, mm:ss',
          'yMMMEd, ms': 'E, MMM d, y, mm:ss',
          "yMMMM 'at' ms": "MMMM y 'at' mm:ss",
        },
      },
      intervalFormats: {
        intervalFormatFallback: '{0} – {1}',
        Bh: { B: 'h B – h B', h: 'h – h B' },
        Bhm: { B: 'h:mm B – h:mm B', h: 'h:mm – h:mm B', m: 'h:mm – h:mm B' },
        d: { d: 'd – d' },
        Gy: { G: 'y G – y G', y: 'y – y G' },
        GyM: {
          G: 'M/y GGGGG – M/y GGGGG',
          M: 'M/y – M/y GGGGG',
          y: 'M/y – M/y GGGGG',
        },
        GyMd: {
          d: 'M/d/y – M/d/y GGGGG',
          G: 'M/d/y GGGGG – M/d/y GGGGG',
          M: 'M/d/y – M/d/y GGGGG',
          y: 'M/d/y – M/d/y GGGGG',
        },
        GyMEd: {
          d: 'E, M/d/y – E, M/d/y GGGGG',
          G: 'E, M/d/y GGGGG – E, M/d/y GGGGG',
          M: 'E, M/d/y – E, M/d/y GGGGG',
          y: 'E, M/d/y – E, M/d/y GGGGG',
        },
        GyMMM: {
          G: 'MMM y G – MMM y G',
          M: 'MMM – MMM y G',
          y: 'MMM y – MMM y G',
        },
        GyMMMd: {
          d: 'MMM d – d, y G',
          G: 'MMM d, y G – MMM d, y G',
          M: 'MMM d – MMM d, y G',
          y: 'MMM d, y – MMM d, y G',
        },
        GyMMMEd: {
          d: 'E, MMM d – E, MMM d, y G',
          G: 'E, MMM d, y G – E, MMM d, y G',
          M: 'E, MMM d – E, MMM d, y G',
          y: 'E, MMM d, y – E, MMM d, y G',
        },
        h: { a: 'h a – h a', h: 'h – h a' },
        H: { H: 'HH – HH' },
        hm: { a: 'h:mm a – h:mm a', h: 'h:mm – h:mm a', m: 'h:mm – h:mm a' },
        Hm: { H: 'HH:mm – HH:mm', m: 'HH:mm – HH:mm' },
        hmv: {
          a: 'h:mm a – h:mm a v',
          h: 'h:mm – h:mm a v',
          m: 'h:mm – h:mm a v',
        },
        Hmv: { H: 'HH:mm – HH:mm v', m: 'HH:mm – HH:mm v' },
        hv: { a: 'h a – h a v', h: 'h – h a v' },
        Hv: { H: 'HH – HH v' },
        M: { M: 'M – M' },
        Md: { d: 'M/d – M/d', M: 'M/d – M/d' },
        MEd: { d: 'E, M/d – E, M/d', M: 'E, M/d – E, M/d' },
        MMM: { M: 'MMM – MMM' },
        MMMd: { d: 'MMM d – d', M: 'MMM d – MMM d' },
        MMMEd: { d: 'E, MMM d – E, MMM d', M: 'E, MMM d – E, MMM d' },
        y: { y: 'y – y' },
        yM: { M: 'M/y – M/y', y: 'M/y – M/y' },
        yMd: { d: 'M/d/y – M/d/y', M: 'M/d/y – M/d/y', y: 'M/d/y – M/d/y' },
        yMEd: {
          d: 'E, M/d/y – E, M/d/y',
          M: 'E, M/d/y – E, M/d/y',
          y: 'E, M/d/y – E, M/d/y',
        },
        yMMM: { M: 'MMM – MMM y', y: 'MMM y – MMM y' },
        yMMMd: {
          d: 'MMM d – d, y',
          M: 'MMM d – MMM d, y',
          y: 'MMM d, y – MMM d, y',
        },
        yMMMEd: {
          d: 'E, MMM d – E, MMM d, y',
          M: 'E, MMM d – E, MMM d, y',
          y: 'E, MMM d, y – E, MMM d, y',
        },
        yMMMM: { M: 'MMMM – MMMM y', y: 'MMMM y – MMMM y' },
      },
      hourCycle: 'h12',
      nu: ['latn'],
      ca: ['gregory'],
      hc: ['h12', '', 'h23', ''],
    },
    locale: 'en',
  });
}
